module.exports = __webpack_public_path__ + "static/media/lock.d0dfda6c.svg";